import PanelGroup from './PanelGroup';

export { default as Panel } from './Panel';
export { default as Divider } from './Divider';
export default PanelGroup;
// ultimatley created this file due to
// https://github.com/insin/nwb/issues/449
